/* Short, deliberate swipes on product photos; page scrolling stays outside the gallery. */
(() => {
  const selector = '.he-gallery-track, .bg-track, media-gallery slideshow-component > slideshow-container > slideshow-slides';
  function init() {
    document.querySelectorAll(selector).forEach(track => {
      if (track.dataset.hauntedSwipe) return;
      track.dataset.hauntedSwipe = 'true';
      track.style.touchAction = 'pinch-zoom';
      track.style.overscrollBehaviorX = 'contain';
      let gesture = null, suppressClickUntil = 0;
      const slides = () => [...track.children].filter(el => !el.hidden && el.getBoundingClientRect().width > 0);
      const positions = () => slides().map(el => el.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft);
      const nearest = points => points.reduce((best, left, i) => Math.abs(left - track.scrollLeft) < Math.abs(points[best] - track.scrollLeft) ? i : best, 0);
      function finish(cancelled = false) {
        if (!gesture) return;
        const g = gesture;
        gesture = null;
        track.style.scrollSnapType = g.snap;
        track.style.scrollBehavior = g.behavior;
        const advance = !cancelled && Math.abs(g.dx) >= 22 ? Math.sign(-g.dx) : 0;
        const index = Math.max(0, Math.min(g.points.length - 1, g.index + advance));
        track.scrollTo({left: g.points[index], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        if (Math.abs(g.dx) > 6 || Math.abs(g.dy) > 6) suppressClickUntil = performance.now() + 400;
      }
      track.addEventListener('touchstart', event => {
        if (event.touches.length !== 1) { finish(true); return; }
        if (event.target.closest('button, a, video, model-viewer, iframe')) return;
        const points = positions();
        if (points.length < 2 || track.scrollWidth <= track.clientWidth + 1) return;
        const touch = event.touches[0];
        gesture = {x: touch.clientX, y: touch.clientY, dx: 0, dy: 0, left: track.scrollLeft, points, index: nearest(points), snap: track.style.scrollSnapType, behavior: track.style.scrollBehavior};
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
      }, {passive: true});
      track.addEventListener('touchmove', event => {
        if (!gesture) return;
        if (event.touches.length !== 1) { finish(true); return; }
        if (event.cancelable) event.preventDefault();
        gesture.dx = event.touches[0].clientX - gesture.x;
        gesture.dy = event.touches[0].clientY - gesture.y;
        track.scrollLeft = gesture.left - gesture.dx * 1.15;
      }, {passive: false});
      track.addEventListener('touchend', () => finish(), {passive: true});
      track.addEventListener('touchcancel', () => finish(true), {passive: true});
      track.addEventListener('click', event => {
        if (performance.now() < suppressClickUntil) { event.preventDefault(); event.stopImmediatePropagation(); }
      }, true);
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
